import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getLogsMaestro(fromDate, toDate) {
    return () => {
        return apiCaller
            .call(api.getLogsMaestro(fromDate, toDate))
            .then(result => {
                return result.data;
            })
            .catch(e => {
                Logger.log('dataActions: getLogsMaestro - ', e);
                throw e;
            });
    };
}
export { getLogsMaestro };



// WEBPACK FOOTER //
// ./environments/logging/data/LogsMaestro/actions.js